import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import { makeStyles } from "@mui/styles";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import ConfigLogo from "../../components/config-logo";
import FrameControls from "../../components/frame-controls";

const useStyles = makeStyles((theme) => ({
	dark: {
		backgroundColor: theme.palette.blueBackground.main,
		color: theme.palette.lightGreyText.main,
		"& a": {
			color: theme.palette.lightGreyText.main,
		},
	},
	privacyPolicyBox: {
		padding: "20px 20px 20px 20px",
		borderRadius: "4px",
		position: "relative",
	},
	backButton: {
		position: "absolute",
		top: "20px",
		right: "20px",
	},
}));

const PrivacyPolicyView = (props) => {
	const classes = useStyles();
	const { t } = useTranslation();
	const [privacyPolicy, setPrivacyPolicy] = useState("");

	React.useEffect(() => {
		fetch("privacy-policy-content.html")
			.then(async (result) => {
				setPrivacyPolicy(await result.text());
			})
			.catch((error) => {
				console.error(error);
			});
	}, []);

	const back = () => {
		window.location.href = "index.html";
	};

	return (
		<>
			<FrameControls />
			<div className={"wrapper"}>
				<Container className={classes.privacyPolicyBox + " " + classes.dark}>
					<Button
						className={classes.backButton}
						onClick={back}
						variant="contained"
						color="primary"
					>
						{t("BACK")}
					</Button>
					<ConfigLogo
						configKey={"logo"}
						defaultLogo={"img/logo.png"}
						height="100%"
					/>
					<a
						href="https://psono.com/"
						target="_blank"
						rel="noopener"
						className="infolabel"
					>
						<i className="fa fa-info-circle" aria-hidden="true" />
					</a>
					<div dangerouslySetInnerHTML={{ __html: privacyPolicy }} />
				</Container>
			</div>
		</>
	);
};
export default PrivacyPolicyView;
